<lib-icon-button
  #mobileMenuTrigger="libDropdownTrigger"
  class="header__burger-button"
  [icon]="mobileMenuTrigger.isOpen ? 'close-square' : 'menu'"
  [isGlobal]="true"
  [libDropdownTrigger]="mobileMenu"
/>

<ng-template #mobileMenu>
  <div class="header__mobile-menu">
    <lib-menu [items]="menuItems" />
    <lib-button
      buttonSize="large"
      buttonStyle="secondary"
      (click)="openRedRockPool()"
    >
      {{ 'header.buttons.to-pool' | translate }}
    </lib-button>
  </div>
</ng-template>

<div class="header__left-wrapper">
  <img
    src="assets/images/logo-sm.png"
    alt="RedRock логотип"
    routerLink="/"
    class="header__logo"
  />
</div>

<div class="header__right-wrapper">
  <rrp-language-selector />

  <lib-button
    buttonStyle="secondary"
    class="header__auth-registration-button"
    (click)="openRedRockPool()"
  >
    {{ 'header.buttons.to-pool' | translate }}
  </lib-button>

  <lib-button
    buttonStyle="secondary"
    class="header__auth-logout-button"
    (click)="logout()"
  >
    <lib-svg-icon icon="logout"></lib-svg-icon>
    <span class="header__auth-logout-button--text">{{
      'header.buttons.logout' | translate
    }}</span>
  </lib-button>
</div>

<ng-template #languageMenu>
  @let currentLanguage = currentLanguage$ | async;

  <div class="header__mobile-menu-language">
    @for (item of languageMenuItems; track $index) {
      <lib-button
        buttonSize="large"
        buttonStyle="ghost"
        [class.active]="item.id === currentLanguage"
        (click)="item.callback?.()"
      >
        {{ item.titleTranslateKey! | translate }}
      </lib-button>
    }
  </div>
</ng-template>
